<div class="dropdown-filter-container" [ngClass]="{'disabled': disabled}">
  <input type="text" pInputText [formControl]="inputControl" #input [placeholder]="placeholder" [size]="size"
    (keyup)="onKeyUp($event)" (click)="openOnClick()" (keydown.tab)="hide()" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"
    hoverPanel [hoverPanelWidth]="hoverPanelWidth" [hoverPanelTemplate]="panel" [hoverPanelZIndex]="hoverPanelZIndex" (hoverPanelClose)="onHoverPanelClose()"
    tooltip [tooltipTitle]="inputControl.value" [tooltipRequiresTruncation]="true" [tooltipRequiresSafe]="true"/>
    <i class="pi pi-chevron-down clickable" (click)="focusInput()"></i>
  </div>

  <ng-template #panel>
    <div [style.height]="gridHeight">
      <div class="ddfHoverPanel shadow" [ngStyle]="{width: hoverPanelWidth + 'px'}" #panelContent>
        <ag-grid-angular
          [style.width] = "'100%'"
          [style.height] = "gridHeight"
          #agGrid
          class="irb-dropdown-filter"
          [suppressMovableColumns]="gridOptions.suppressMovableColumns"
          [suppressHorizontalScroll]="true"
          [suppressContextMenu]="true"
          [columnDefs]="gridOptions.columnDefs"
          [components]="frameworkComponents"
          (gridReady)="onGridReady($event)"
          [gridAutoHeight]="gridOptions.gridAutoHeight"
          [rowHeight]=30
          [headerHeight]="0"
          [overlayLoadingTemplate]="gridOptions.overlayLoadingTemplate"
          [overlayNoRowsTemplate]="gridOptions.overlayNoRowsTemplate"
          [rowSelection]="gridOptions.rowSelection"
          (rowClicked)="onRowClicked($event)"
          (cellClicked)="$event.event.stopPropagation()"
          >
        </ag-grid-angular>
        @if (showAddNewButton) {
          <div class="ddf-add-new-button">
            <button class='btn-medium-secondary' (click)="addNewItemClick()">{{addNewItem.button}}</button>
          </div>
        }
      </div>
    </div>
  </ng-template>
